export const UnclassifiedDocumentType = {
  UnclassifiedOperator: 'UNCLASSIFIED_OPERATOR',
  UnclassifiedTool: 'UNCLASSIFIED_TOOL',
  UnclassifiedTracability: 'UNCLASSIFIED_TRACABILITY'
};

export const justifications = {
  APTITUDE_ATTESTATION: 'APTITUDE_ATTESTATION'
};
